/** Answer storage and retrieval service (uses vue-cookie for cookie handling) */
import VueCookie from "vue-cookie"
/** default answer set cookie and url query parameter name */
const PARAM_NAME = 'fill';
const COOKIE_POLICY = 'CIVICCookieGroups';

let AnswerPreload = {
    // get cookie by name
    findInCookie: function(name){
        return VueCookie.get(name);
    },
    // get url query parameter by name
    findInQuery: function(name) {
        let url = window.location.href;
        name = name.replace(/[[\]]/g, '\\$&');
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
        if(!results || !results[2]) return null;
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    // clear cookie
    clearCookie(name){
        if (! name ) name = PARAM_NAME;
        VueCookie.delete(name);
    },
    // retrieve answer set from cookie or url
    checkPreload: function(store) {
        let answers = this.findInQuery(PARAM_NAME);
        if (!answers) {
            answers = this.findInCookie(PARAM_NAME);
        } else {
            store.commit('setAdmin', true);
            this.clearCookie(PARAM_NAME);
        }
        if (!answers) {
            return false;
        }
        store.dispatch("preLoadAnswers", this.parseAnswers(answers));

        return true;
    },
    // encoded answer string to object
    parseAnswers: function(string) {
        return JSON.parse(atob(string));
    },
    // set encoded answer string to cookie
    setResultCookie: function(answerString) {
        if (this.checkPolicy()) {
            VueCookie.set(PARAM_NAME, answerString, 30);
        }
    },
    // generate admin access url
    getAdminUrl: function(store) {
        return store.getters.getUrl
            + '?'
            + PARAM_NAME
            + '='
            + store.getters.getAnswerString;
    },

    checkPolicy: function() {
        let policy = this.findInCookie(COOKIE_POLICY);
        if (!policy || policy.length < 1) {
            return false;
        }
        let groups = policy.substring(1, (policy.length - 1)).split(',');

        return (groups.indexOf('functional') !== -1);
    }
};

export default AnswerPreload;